import CommonApp from '../../app.js';
import bankCheckTemplate from './bank-check-example.html';

var BankCheckExample = function() {
    return {
        scope: {
            bankCheckLinkTitle: '<',
            bankCheckTitle: '<',
            bankCheckCloseImage: '<',
            bankCheckImage: '<'
        },
        controller: BankCheckExampleController,
        controllerAs: 'ctrl',
        bindToController: true,
        template: bankCheckTemplate
    };
};

var BankCheckExampleController = function($scope) {
    var self = this;
    self.isOpen = false;
    self.toggleCheckImage = function() {
        self.isOpen = !self.isOpen;
    };
};

BankCheckExampleController.$inject = ['$scope'];

CommonApp.module.controller('bankCheckExampleController', BankCheckExampleController);

CommonApp.module.directive('nsBankCheckExample', BankCheckExample);



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/directives/bank-check-example/bank-check-example.js
// module id = 265
// module chunks = 0